
const FullAdviceModal = () => {
    return <div>
        {'Markdown content bla bla bla'}
    </div>
}

export default FullAdviceModal
